import { useState } from 'react';
import { fetchWithAuth, uploadToS3, PHOTOS_API } from '../utils/api';

export function usePhotoUpload() {
  const [isUploading, setIsUploading] = useState({});
  const [uploadProgress, setUploadProgress] = useState({});
  const [error, setError] = useState(null);

  const uploadPhoto = async ({ file, entityType, entityId, onSuccess }) => {
    const uploadKey = entityId;
    
    try {
      setError(null);
      setIsUploading(prev => ({ ...prev, [uploadKey]: true }));
      setUploadProgress(prev => ({ ...prev, [uploadKey]: 0 }));

      console.log('Requesting upload URL for judge photo...');
      
      // Create the request payload that matches the photos Lambda function's expectations
      const uploadRequest = {
        fileName: file.name,
        contentType: file.type,
        type: entityType, // 'judges'
        entityId: entityId,
        purpose: 'profile', // For judge profile photos
        isPublic: true
      };

      console.log('Upload request payload:', uploadRequest);

      // Step 1: Get presigned URL from photos API
      const response = await fetchWithAuth(`${PHOTOS_API}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(uploadRequest)
      });

      console.log('Upload URL response:', response);

      if (!response.uploadUrl) {
        throw new Error('No upload URL received from server');
      }

      // Step 2: Upload file to S3 using the presigned URL
      await uploadToS3(response.uploadUrl, file, (progress) => {
        console.log(`Upload progress: ${progress}%`);
        setUploadProgress(prev => ({ ...prev, [uploadKey]: progress }));
      });

      console.log(`Upload complete, public URL: ${response.publicUrl}`);

      // Use the public URL for judge photos (permanent URL)
      const publicUrl = response.publicUrl;
      
      if (onSuccess) {
        onSuccess(publicUrl);
      }

      return publicUrl;

    } catch (err) {
      console.error('Upload error:', err);
      setError(err.message);
      throw err;
    } finally {
      setIsUploading(prev => ({ ...prev, [uploadKey]: false }));
      // Clear progress after a short delay
      setTimeout(() => {
        setUploadProgress(prev => {
          const newProgress = { ...prev };
          delete newProgress[uploadKey];
          return newProgress;
        });
      }, 2000);
    }
  };

  return {
    isUploading,
    uploadProgress,
    error,
    uploadPhoto
  };
} 